module.exports = __webpack_public_path__ + "static/media/Poppins-Thin.c0fafa83.ttf";